import apiService from './apiService';

export const contactService = {
    async listContacts({ favoritesOnly = false, q = null } = {}) {
        const params = new URLSearchParams();
        if (favoritesOnly) params.set('favorites_only', 'true');
        if (q) params.set('q', q);
        const qs = params.toString();
        return apiService.get(`/api/contacts${qs ? `?${qs}` : ''}`);
    },
    async getContact(contactId) {
        return apiService.get(`/api/contacts/${contactId}`);
    },
    async createContact(data) {
        return apiService.post('/api/contacts', data);
    },
    async updateContact(contactId, updates) {
        return apiService.patch(`/api/contacts/${contactId}`, updates);
    },
    async deleteContact(contactId) {
        return apiService.delete(`/api/contacts/${contactId}`);
    },
    async toggleFavorite(contactId, value = null) {
        const body = value === null ? {} : { is_favorite: !!value };
        return apiService.post(`/api/contacts/${contactId}/favorite`, body);
    },
    async listNotes(contactId) {
        return apiService.get(`/api/contacts/${contactId}/notes`);
    },
    async addNote(contactId, { content, source = 'manual', conversation_id = null, message_id = null } = {}) {
        return apiService.post(`/api/contacts/${contactId}/notes`, {
            content, source, conversation_id, message_id,
        });
    },
    async deleteNote(contactId, noteId) {
        return apiService.delete(`/api/contacts/${contactId}/notes/${noteId}`);
    },
    async getInteractions(contactId) {
        return apiService.get(`/api/contacts/${contactId}/interactions`);
    },

    // ── Agenda TO Contacts — Phase A network handshake / severance / blocks ──
    // Thin wrappers over the /api/contacts network endpoints (contact_network
    // blueprint). Discovery is a 200-with-`state` discriminator (never leaks
    // whether a hidden/blocked user exists), so callers branch on `res.state`.

    // GET /api/contacts/discover?email= — email-only lookup; returns a `state`
    // discriminator (invalid/self/not_found/found/pending_sent/pending_received/linked).
    async discover(email) {
        return apiService.get(`/api/contacts/discover?email=${encodeURIComponent(email || '')}`);
    },
    // GET /api/contacts/requests — { received:[...], sent:[...] } (pending only).
    async listRequests() {
        return apiService.get('/api/contacts/requests');
    },
    // POST /api/contacts/requests — open a handshake to the given email.
    async sendRequest(email) {
        return apiService.post('/api/contacts/requests', { email });
    },
    // POST /api/contacts/requests/<id>/respond — recipient accepts/declines.
    async respondRequest(requestId, decision) {
        return apiService.post(`/api/contacts/requests/${requestId}/respond`, { decision });
    },
    // DELETE /api/contacts/requests/<id> — requester cancels a pending request.
    async cancelRequest(requestId) {
        return apiService.delete(`/api/contacts/requests/${requestId}`);
    },
    // POST /api/contacts/<contact_id>/uncontact — full two-way severance.
    async uncontact(contactId) {
        return apiService.post(`/api/contacts/${contactId}/uncontact`, {});
    },
    // GET /api/contacts/blocks — { blocks:[...] }.
    async listBlocks() {
        return apiService.get('/api/contacts/blocks');
    },
    // POST /api/contacts/blocks — block (severs any link first, then hides).
    async block(email) {
        return apiService.post('/api/contacts/blocks', { email });
    },
    // DELETE /api/contacts/blocks/<id> — unblock (restores discoverability only).
    async unblock(blockId) {
        return apiService.delete(`/api/contacts/blocks/${blockId}`);
    },
};

export default contactService;
